<template>
  <div>
    <v-card
      v-for="order in orders"
      :key="order.ids"
      :color="getStatusColor(order)"
      class="mb-4"
    >
      <v-card-item>
        <template v-slot:prepend>
          <v-icon
            :icon="order.error ? 'mdi-alert' : 'mdi-check-circle'"
            :color="order.error ? 'error' : 'success'"
            size="large"
          ></v-icon>
        </template>
        
        <v-card-title>
          <div class="d-flex align-center">
            <span class="mr-4">Orders {{ order.ids }}</span>
            <v-chip
              v-if="order.invoice_id"
              color="primary"
              size="small"
              class="mr-4"
            >
              Invoice: {{ order.invoice_id }}
            </v-chip>
            <span class="text-subtitle-1">PO: {{ order.ponumber }}</span>
          </div>
        </v-card-title>

        <v-card-subtitle v-if="order.error" class="text-error">
          {{ order.error }}
        </v-card-subtitle>

        <v-card-text>
          <div class="d-flex align-center">
            <span class="text-caption text-medium-emphasis mr-2">Part Numbers:</span>
            <span>{{ order.partnumbers }}</span>
          </div>
        </v-card-text>
      </v-card-item>
    </v-card>

    <!-- No Orders Message -->
    <v-card
      v-if="orders.length === 0"
      class="text-center pa-4"
    >
      <v-icon
        icon="mdi-package-variant"
        size="64"
        color="grey"
      ></v-icon>
      <div class="text-h6 mt-4">No orders submitted</div>
    </v-card>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  orders: {
    type: Array,
    required: true,
    default: () => []
  }
})

const getStatusColor = (order) => {
  if (order.error) return 'error-lighten-4'
  return 'success-lighten-4'
}
</script> 